import React from "react";
import { Gift } from "lucide-react";

export default function PromoBanner({ promo }) {
  if (!promo) return null;
  return (
    <div
      data-testid="promo-banner"
      className="fixed top-0 left-0 right-0 z-[60] bg-[color:var(--primary)] text-neutral-900"
    >
      <div className="max-w-[1400px] mx-auto px-4 md:px-10 h-10 flex items-center justify-center gap-3 text-xs md:text-sm">
        <Gift size={14} strokeWidth={2} />
        <span className="font-medium tracking-wide">
          10% OFF YOUR FIRST DETAIL ·{" "}
          <span className="font-mono font-semibold uppercase">{promo}</span>{" "}
          applied
        </span>
        <a
          href="#book"
          data-testid="promo-banner-cta"
          className="hidden sm:inline-flex ml-2 underline underline-offset-4 hover:no-underline font-semibold"
        >
          Claim now →
        </a>
      </div>
    </div>
  );
}
